import React, { useEffect } from 'react';
import Banner from 'comps/banner';
import COLORS from 'constants/colors';
import { Text } from '@cuemath/web-comps';
import { useGetMaintenance } from 'actions/maintenance';
import { useSelector } from 'react-redux';
import { getCookie, getFormattedDate } from 'utils';

const Maintenance = () => {
  const authId = useSelector(({ auth }) => auth?.user_id);
  const userId = authId || getCookie('user_id') || getCookie('emp_id');

  const { data, get: getMaintenance, isProcessed } = useGetMaintenance();
  const {
    start_ts: maintenanceStartTs,
    end_ts: maintenanceEndTs,
    show_pre_maintenance_banner: showPreMaintenanceBanner,
  } = data || {};

  useEffect(() => {
    if (userId) {
      getMaintenance(userId);
    }
  }, [getMaintenance, userId]);

  if (isProcessed && showPreMaintenanceBanner) {
    const text = (
      <Text align="center" variant="body1Regular" weight="400">
        <strong>
          Downtime:{' '}
          {`${getFormattedDate(
            maintenanceStartTs * 1000,
            'MMM D, h:mm A',
          )} - ${getFormattedDate(maintenanceEndTs * 1000, 'h:mm A')}`}{' '}
        </strong>
        (Due to a scheduled maintenance, all our platforms and app will not be accessible
        during this time.)
      </Text>
    );

    return <Banner backgroundColor={COLORS.ORANGE_3} text={text} />;
  }

  return null;
};

export default Maintenance;
